import React from 'react'
import PropTypes from 'prop-types'
import { parse } from 'date-fns'
import theme from 'styles/theme'
import DatePicker from 'react-datepicker'
import { Eyebrow } from 'components/Typography'
import FormLabel from '../FormLabel'
import FormDatepickerInput from './FormDatepickerInput'
import FormErrorMessage from '../FormErrorMessage'
import FormHelpLabel from '../FormHelpLabel'
import { Wrapper, DatepickerWrapper } from './FormDatepicker.style'

const FormDatepicker = ({
  blockedDates,
  daysOfWeek,
  errorMessage,
  handleDateChange,
  hasError,
  helpLabel,
  isDisabled,
  label,
  locale,
  name,
  startDate,
  value,
}) => {
  const dayIsOpen = (date) => {
    return daysOfWeek[date.getDay()]
  }

  const blockedDatesFormatted = (dateArray) => {
    const newArray = []
    dateArray.forEach((date) => {
      newArray.push(parse(date))
    })
    return newArray
  }

  return (
    <Wrapper>
      <FormLabel hasError={hasError} isDisabled={isDisabled}>
        <Eyebrow color={theme.colors.sagedark}>
          {label}
          {!!helpLabel && <FormHelpLabel>{helpLabel}</FormHelpLabel>}
        </Eyebrow>
      </FormLabel>
      <DatepickerWrapper hasError={hasError} isDisabled={isDisabled}>
        <DatePicker
          selected={value}
          locale={locale}
          onChange={(newDate) => handleDateChange(newDate, name)}
          excludeDates={blockedDatesFormatted(blockedDates)}
          filterDate={dayIsOpen}
          minDate={startDate}
          customInput={
            <FormDatepickerInput
              date={value}
              hasError={hasError}
              isDisabled={isDisabled}
            />
          }
        />
      </DatepickerWrapper>

      {hasError && <FormErrorMessage errorMessage={errorMessage} />}
    </Wrapper>
  )
}

FormDatepicker.propTypes = {
  blockedDates: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
  daysOfWeek: PropTypes.arrayOf(PropTypes.bool),
  errorMessage: PropTypes.string,
  handleDateChange: PropTypes.func.isRequired,
  hasError: PropTypes.bool,
  helpLabel: PropTypes.string,
  isDisabled: PropTypes.bool,
  label: PropTypes.string,
  locale: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  startDate: PropTypes.instanceOf(Date).isRequired,
  value: PropTypes.instanceOf(Date).isRequired,
}

FormDatepicker.defaultProps = {
  blockedDates: [],
  daysOfWeek: [true, true, true, true, true, true, true],
  errorMessage: '',
  hasError: false,
  helpLabel: '',
  isDisabled: false,
  label: '',
}

export default FormDatepicker
